const data = [
  {
    id: 1,
    title: "Personal Info",
    content: (
      <>
        <img
          src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSSvuIPg2gYd3V-3ta8wMStRNGBOFu4zFOE9w&s"
          width={500}
          alt=""
        />
        <h1>Personal Info</h1>
      </>
    ),
  },
  {
    id: 2,
    title: "Account Info",
    content: (
      <>
        <img
          src="https://support.zno.com/hc/article_attachments/26001805560215"
          width={500}
          alt=""
        />
        <h1>Account Info</h1>
      </>
    ),
  },
  {
    id: 3,
    title: "Payment",
    content: (
      <>
        <img
          src="https://www.dreamhost.com/blog/wp-content/smush-webp/2017/11/online-payment-gateways-2.jpg.webp"
          width={500}
          alt=""
        />
        <h1>Payment</h1>
      </>
    ),
  },
  {
    id: 4,
    title: "Configuration",
    content: (
      <>
        <img
          src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR_YP60bGrynx5-XfeovYIrx5iTTOF4SXVH_g&s"
          width={500}
          alt=""
        />
        <h1>Configuration</h1>
      </>
    ),
  },
];

export default data;
